import { Injectable } from '@angular/core';

import { Button } from './Button';
import { CameraLayers } from '../../enum/CameraLayers';
import { StageService } from '../../services/stage.service';
import { AwningService } from '../../services/awning/awning.service';

declare const THREE: any;

@Injectable()
export class AwningResizeControls extends (THREE.Object3D as { new (): any }) {
  constructor(
    private stageService: StageService,
    private awningService: AwningService
  ) {
    super();
    const horizontalResizeTexture = new THREE.TextureLoader().load(
      'assets/images/sprites/Add_awning.png'
    );
    const left = new Button(horizontalResizeTexture, 'left', CameraLayers.HORIZONTAL_RESIZE);
    const right = new Button(horizontalResizeTexture, 'right', CameraLayers.HORIZONTAL_RESIZE);
    this.add(left);
    this.add(right);
    this.visible = false;
    this.name = 'awningResizeControls';
    this.stageService.add(this);
  }

  update(awning) {
    // place controls to the edges
    // of base awning or (if either
    // exist) place on the last in
    // row right or left awning edge
    const groupPosition = this.awningService.getCenter(awning);
    const length = this.awningService.getSizes(awning).x;
    const sprites = this.children;
    this.position.copy(groupPosition);
    awning.getWorldQuaternion(this.quaternion);
    sprites[0].position.x = -length / 2;
    sprites[1].position.x = length / 2;
  }
}



// WEBPACK FOOTER //
// ./src/app/custom/Controls/AwningResizeControls.ts